<div class="success-page">
  <!-- Decorative blobs (reuse auth shell variables from theme) -->
  <div class="success-blob success-blob--top"></div>
  <div class="success-blob success-blob--bottom"></div>
  <div class="success-blob success-blob--right"></div>

  <!-- Centred card -->
  <div class="success-card">
    <!-- Logo -->
    <a [href]="websiteUrl" class="block mb-8 flex justify-center">
      <img
        [priority]="1"
        alt="BusPro Logo"
        class="w-40"
        height="188"
        ngSrc="logo-no-border.png"
        width="600"
      />
    </a>

    <!-- Animated checkmark circle -->
    <div class="success-icon-wrapper">
      <div class="success-icon-ring"></div>
      <div class="success-icon-circle">
        <svg
          class="success-check"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="3"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      </div>
    </div>

    <!-- Headline -->
    <h1 class="success-title">
      @if (userName) {
        Welcome, {{ userName }}!
      } @else {
        You're all set!
      }
    </h1>
    <p class="success-subtitle">
      Your BusPro account has been activated successfully. You can now sign in
      and start managing your bus fleet operations.
    </p>

    <!-- CTA buttons -->
    <div class="success-actions">
      <a class="btn btn-primary btn-lg success-btn-primary" routerLink="/passport/login">
        Sign In to Company Portal
      </a>
      <a [href]="websiteUrl" class="btn btn-ghost btn-md success-btn-ghost">
        Back to Website
      </a>
    </div>

    <!-- Copyright -->
    <p class="success-copyright">
      Copyright &nbsp;&#64;{{ currentDate | date: 'YYYY' }}. BusPro. All rights reserved.
    </p>
  </div>
</div>
